import { Component, OnInit } from '@angular/core';
import { AttendanceService } from 'src/app/services/attendance/attendance.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-student-daily-attendance',
  templateUrl: './student-daily-attendance.component.html',
  styleUrls: ['./student-daily-attendance.component.css']
})
export class StudentDailyAttendanceComponent implements OnInit {

  constructor(private attendanceservice: AttendanceService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ClassList: any;
  SectionList: any;
  StudentAttendanceList = [];
  Submitted: boolean = false;


  StudentDailyAttendancetModel = {
    StudentAttendanceID: 0,
    ClassID: 0,
    SectionID: 0,
    ClassSectionID: "",
    AttendanceDate: moment(new Date()).format('DD-MMM-YYYY'),
  }

  Clear() {
    this.StudentDailyAttendancetModel.ClassID = 0;
    this.StudentDailyAttendancetModel.SectionID = 0;
    this.StudentDailyAttendancetModel.ClassSectionID='';
    this.StudentDailyAttendancetModel.AttendanceDate = moment(new Date()).format('DD-MMM-YYYY');
    this.Submitted = false;
    this.StudentAttendanceList=[];

  }
  SearchValidation() {
    return this.StudentDailyAttendancetModel.ClassID == 0 || this.StudentDailyAttendancetModel.SectionID == 0;
  }
  GetDailyStudentAttendance(valid) {
    this.Submitted = true;
    this.StudentAttendanceList = [];
    this.AllAbsent=false;
    this.AllPresent=false;
    if (valid && !this.SearchValidation()) {
      this.StudentDailyAttendancetModel.AttendanceDate = this.StudentDailyAttendancetModel.AttendanceDate != null && this.StudentDailyAttendancetModel.AttendanceDate != '' ? moment(this.StudentDailyAttendancetModel.AttendanceDate).format('DD-MMM-YYYY') : '';
      this.spinnerService.show();
      this.attendanceservice.GetDailyStudentAttendance(JSON.stringify(this.StudentDailyAttendancetModel)).subscribe((data: any) => {
        this.StudentAttendanceList = data.StudentAttendanceList;
        this.Submitted = false;
        this.AllPresent=true;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

        var totalP = 0; var totalA = 0; var totalI = 0; var totalF = 0; var totalO = 0; var totalH = 0;
        for (var i = 0; i < this.StudentAttendanceList.length; i++) {


          if (this.StudentAttendanceList[i].CurrentStatus == 'P') {
            totalP = totalP + 1
          }
          if (this.StudentAttendanceList[i].CurrentStatus == 'A') {
            totalA = totalA + 1
          }
          if (this.StudentAttendanceList[i].CurrentStatus == 'I') {
            totalI = totalI + 1
          }
          if (this.StudentAttendanceList[i].CurrentStatus == 'F') {
            totalF = totalF + 1
          }
          if (this.StudentAttendanceList[i].CurrentStatus == 'O') {

            totalO = totalO + 1;


          }
          if (this.StudentAttendanceList[i].CurrentStatus == 'H') {
            totalH = totalH + 1
          }

        }

        this.totalP = totalP; this.totalA = totalA; this.totalI = totalI; this.totalF = totalF; this.totalO = totalO; this.totalH = totalH;
        this.total = this.StudentAttendanceList.length;
      });
    }


  };
  totalP = 0;
  totalA = 0;
  totalI = 0;
  totalF = 0;
  totalO = 0;
  totalH = 0;
  total = 0;
  SaveDailyStudentAttendance() {
    this.Submitted = true;
    if (!this.SearchValidation()) {
    this.spinnerService.show();
    this.attendanceservice.SaveDailyStudentAttendance(JSON.stringify(this.StudentAttendanceList), JSON.stringify(this.StudentDailyAttendancetModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.Submitted = true;
      this.GetDailyStudentAttendance(true);
      this.globalHelper.CheckActionStatus(data);

    });
  }
  };

  ngOnInit() {
    this.GetClassSection();
    // this.GetSection();
  }


  ClassSectionList: any;
  GetClassSection() {
    this.lookupservice.GetLookupsList('CTClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;

    });

  };


  SetID() {
    this.StudentAttendanceList=[];
    this.StudentDailyAttendancetModel.ClassID = 0;
    this.StudentDailyAttendancetModel.SectionID = 0;
    if (this.StudentDailyAttendancetModel.ClassSectionID != "") {
      var strClassSectionID = this.StudentDailyAttendancetModel.ClassSectionID.split('-');
      this.StudentDailyAttendancetModel.ClassID = parseInt(strClassSectionID[0]);
      this.StudentDailyAttendancetModel.SectionID = parseInt(strClassSectionID[1]);

    }



  }
  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetSection() {
    this.StudentDailyAttendancetModel.SectionID = 0;
    var itemBo = {
      'ItemId': this.StudentDailyAttendancetModel.ClassID,
    };
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };
  AllAbsent=false;
  AllPresent=false;
  PresentAll() {
    if (this.AllPresent) {
        for (var i = 0; i < this.StudentAttendanceList.length; i++) {
            this.StudentAttendanceList[i].CurrentStatus = 'P';
            this.AllAbsent=false;
        }
    }
    if (!this.AllPresent) {
        for (var i = 0; i < this.StudentAttendanceList.length; i++) {
            this.StudentAttendanceList[i].CurrentStatus = 'A';
            this.AllAbsent=true;
        }
    }
}



}
